/**
 * Module: Hero Swiper Slider
 * Description: Inizializza gli slider Swiper usati nelle hero.
 */

export function initHeroSlider() {
	if (typeof Swiper === "undefined") {
		console.warn("Swiper non disponibile per gli slider Hero.");
		return;
	}

	initMainHeroSliders();
	initFeaturedHeroMediaSliders();
}

function getAutoplayConfig(slider, slidesCount) {
	if (slidesCount <= 1) {
		return false;
	}

	const autoplayDelay = parseInt(slider.dataset.swiperAutoplay, 10) || 5000;

	return {
		delay: autoplayDelay,
		disableOnInteraction: false,
		pauseOnMouseEnter: false,
	};
}

function initMainHeroSliders() {
	const sliders = document.querySelectorAll(".swiper-hero-slider");

	if (!sliders.length) {
		return;
	}

	sliders.forEach((slider) => {
		if (slider.dataset.swiperInitialized === "true") {
			return;
		}

		const slidesCount = slider.querySelectorAll(".swiper-slide").length;
		const speed = parseInt(slider.dataset.swiperSpeed, 10) || 1000;
		const loop = slidesCount > 1 && slider.dataset.swiperLoop === "true";
		const paginationEl = slider.querySelector(".swiper-pagination-hero-slider");

		if (!slidesCount) {
			return;
		}

		new Swiper(slider, {
			spaceBetween: 0,
			loop: loop,
			speed: speed,
			autoplay: getAutoplayConfig(slider, slidesCount),
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			pagination: paginationEl ? {
				el: paginationEl,
				clickable: true,
			} : false,
		});

		slider.dataset.swiperInitialized = "true";
	});
}

function initFeaturedHeroMediaSliders() {
	const sliders = document.querySelectorAll(".swiper-featured-hero-media-slider");

	if (!sliders.length) {
		return;
	}

	sliders.forEach((slider) => {
		if (slider.dataset.swiperInitialized === "true") {
			return;
		}

		const slidesCount = slider.querySelectorAll(".swiper-slide").length;
		const speed = parseInt(slider.dataset.swiperSpeed, 10) || 900;
		const loop = slidesCount > 1 && slider.dataset.swiperLoop === "true";
		const paginationEl = slider.querySelector(".s-featured-hero__media-slider-pagination");

		if (!slidesCount) {
			return;
		}

		new Swiper(slider, {
			spaceBetween: 0,
			loop: loop,
			speed: speed,
			autoplay: getAutoplayConfig(slider, slidesCount),
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			pagination: paginationEl ? {
				el: paginationEl,
				clickable: true,
			} : false,
		});

		slider.dataset.swiperInitialized = "true";
	});
}
